/* eslint-disable @typescript-eslint/indent */

export enum KayakServiceType {
  FLIGHTS = 'flights',
  CAR_RENTAL = 'cars',
}

export const serviceTypeMap: Record<KayakServiceType, 'flights' | 'cars'> = {
  [KayakServiceType.FLIGHTS]: 'flights',
  [KayakServiceType.CAR_RENTAL]: 'cars',
};

export type KayakIntegrationData = {
  domain: string,
  from: string | null,
  to: string | null
};

export type KayakServiceKeys = 'origin' | 'destination'
  | 'location' | 'location2'
  | 'depart_date_iso' | 'return_date_iso'
  | 'pickup_date_iso' | 'dropoff_date_iso';
